import useValidation from "../../hooks/useValidation"
import { useEffect, useState } from "react"
import FieldDescription from "../tools/FieldDescription"
import { format, parse, isValid } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";
import { RegistrationReferenceType } from "../../static/types/commonTypes/registrationReferenceType"
import { registrationReferenceValidationSchema } from "../../utils/validation/registrationReferenceValidationSchema"

type registrationReferenceProps = {
    checked: boolean,
    registrationReference: RegistrationReferenceType,
    changeRegistrationReference: ( registrationReference: Partial<RegistrationReferenceType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function RegistrationReference({
    checked,
    registrationReference,
    changeRegistrationReference,
    onValidationChange
}: registrationReferenceProps ) {

    const { errors, isValid: isDataValid } = useValidation(registrationReference, registrationReferenceValidationSchema );

    useEffect(() => {
        onValidationChange(isDataValid);
    }, [isDataValid, onValidationChange]);

    const [ acteDate, setActeDate ] = useState<string>("");
    const [ registrationDate, setRegistrationDate ] = useState<string>("");

    useEffect(() => {
        if (registrationReference.acteDate) {
            const parsedDate = parse(registrationReference.acteDate, "dd/MM/yyyy", new Date());
            setActeDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
        if (registrationReference.registrationDate) {
            const parsedDate = parse(registrationReference.registrationDate, "dd/MM/yyyy", new Date());
            setRegistrationDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
    }, [registrationReference]);

    const handleActeDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
        const formattedDate = isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : "";

        setActeDate(inputDate);
        changeRegistrationReference({ acteDate: formattedDate });
    };

    const handleRegistartionDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
        const formattedDate = isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : "";

        setRegistrationDate(inputDate);
        changeRegistrationReference({ registrationDate: formattedDate });
    };

    const openDatePicker = (id: string) => {
        const input = document.getElementById(id) as HTMLInputElement;
        input?.showPicker();
    };

    return (
        <div className="mb-3 row">

            <label htmlFor="acteDate" className="col-sm-2 col-form-label">
                Date de l'acte <strong className="text-danger">*</strong>
            </label>

            <div className="col-sm-10 mb-3">
                <input
                    className={`description-input form-control ${checked && errors.acteDate ? 'is-invalid' : ''}`}
                    type="date"
                    id="acteDate"
                    value={acteDate}
                    onChange={handleActeDateChange}
                    onClick={() => openDatePicker("acteDate")}
                    placeholder="JJ/MM/AAAA"
                />

                {checked && errors.acteDate && <div className="invalid-feedback">{errors.acteDate}</div>}
                <FieldDescription description="Date de l'acte au format : jj/mm/aaaa" />
            </div>

            <label htmlFor="registrationDate" className="col-sm-2 col-form-label">
                Date enregistr. <strong className="text-danger">*</strong>
            </label>

            <div className="col-sm-10 mb-3">
                <input
                    className = { `description-input form-control ${checked && errors.registrationDate ? 'is-invalid' : ''}`}
                    type = "date"
                    id = "registrationDate"
                    value = { registrationDate }
                    onChange = { handleRegistartionDateChange }
                    onClick = {() => openDatePicker("registrationDate")}
                    placeholder = "JJ/MM/AAAA"
                />

                {checked && errors.registrationDate && <div className="invalid-feedback">{errors.registrationDate}</div>}
                <FieldDescription description="Date d'enregistrement au format : jj/mm/aaaa" />
            </div>

            <label htmlFor="mortgage" className="col-sm-2 col-form-label">
                Hypothèque <strong className="text-danger">*</strong>
            </label>

            <div className="col-sm-10 mb-3">
                <input
                    className={ `description-input form-control ${checked && errors.mortgage ? 'is-invalid' : ''}`}
                    type="text"
                    id="mortgage"
                    value={registrationReference.mortgage || ""}
                    onChange={event => changeRegistrationReference({ mortgage: event.target.value })}
                />

                
                {checked && errors.mortgage && <div className="invalid-feedback">{errors.mortgage}</div>}
            </div>

        </div>
    );
}
